import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let SellDetail = class SellDetail extends Vue {
    constructor() {
        super(...arguments);
        this.limitTime = [];
    }
    get limitTimeFilter() {
        return this.limitTime.filter((item, index) => !(index === 0 && item === '00'));
    }
    async mounted() {
        this.countdown(this.end_time);
    }
    getCountdownClass(type) {
        switch (type) {
            case 'limit_buy':
                return `limit_buy`;
            case 'group':
                return `group`;
            case 'presell':
                return `presell`;
            case 'limit_free':
                return `limit_free`;
        }
    }
    getDayClass(type) {
        switch (type) {
            case 'limit_buy':
                return `limit_buy_day`;
            case 'group':
                return `group_day`;
            case 'presell':
                return `presell_day`;
            case 'limit_free':
                return `limit_free_day`;
        }
    }
    countdown(end) {
        if (this.snapshotTime) {
            this.limitTime = this.snapshotTime.split(' ');
            return;
        }
        end = end.replace(/-/g, '/');
        // 相差的毫秒数
        const msec = new Date(end).getTime() - new Date().getTime();
        if (msec <= 0)
            return;
        let remainTime = Date.formatMs(msec, 'DD hh mm ss');
        this.remainTime = remainTime;
        this.limitTime = remainTime.split(' ');
        // 一秒后递归
        setTimeout(() => {
            this.countdown(end);
        }, 1000);
    }
};
tslib_1.__decorate([
    Prop()
], SellDetail.prototype, "type", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], SellDetail.prototype, "end_time", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], SellDetail.prototype, "snapshotTime", void 0);
SellDetail = tslib_1.__decorate([
    Component({
        filters: {
            seperatePrice(price) {
                if (!price)
                    return {};
                let prices = price.toString().split('.');
                return { integer: prices[0], decimal: prices[1] };
            },
            integerPrice(price) {
                return price.integer;
            },
            decimalPrice(price) {
                return price.decimal;
            },
        },
    })
], SellDetail);
export default SellDetail;
